import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, switchToFrench, switchToEnglish } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      gap: '0.75rem',
      alignItems: 'center'
    }}>
      <button
        onClick={switchToFrench}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          fontSize: '0.875rem',
          fontWeight: '500',
          letterSpacing: '0.15em',
          color: language === 'fr' ? '#ffffff' : '#a3a3a3',
          transition: 'all 0.3s ease',
          padding: '0.25rem 0.5rem'
        }}
        aria-label="Français"
        title="Français"
      >
        FR
      </button>

      <span style={{ color: '#525252', fontSize: '0.75rem' }}>|</span>

      <button
        onClick={switchToEnglish}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          fontSize: '0.875rem',
          fontWeight: '500',
          letterSpacing: '0.15em',
          color: language === 'en' ? '#ffffff' : '#a3a3a3',
          transition: 'all 0.3s ease',
          padding: '0.25rem 0.5rem'
        }}
        aria-label="English"
        title="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
